import NavBar from "./components/NavBar";
import Home from "./components/Home";
import About from "./components/About";
import Menu from "./components/Menu";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";



function App() {
  return (
    <div>
      <NavBar />
      <Home />
      <About />
      <Menu />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
